import React from 'react';
import PropTypes from 'prop-types';
import './GroupHeader.scss';
import { getWordEnding } from '../../../../utils/shared/commonUtils';

const GroupHeader = ({ id, name, count }) => (
    <div className="group-header-container">
        <div className="group-square">
            <div className="group-title">GROUP</div>
            <div className="group-id">{id}</div>
        </div>
        <div className="group-name-container">
            <span className="name">{name}</span>
            <i className="icon-amplify-person" />
            <span className="font-weight-bold">{` ${count} `}</span>
            {`Student${getWordEnding(count)}`}
        </div>
    </div>
);

GroupHeader.defaultProps = {
    id: null,
    name: '',
    count: 0,
};

GroupHeader.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    count: PropTypes.number,
};

export default GroupHeader;
